var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.954545 15C0.684091 15 0.457545 14.904 0.274909 14.712C0.0922727 14.52 0.000636364 14.2827 0 14V1C0 0.71667 0.0916364 0.479337 0.274909 0.288003C0.458182 0.0966702 0.684727 0.000670115 0.954545 3.44827e-06C1.22436 -0.000663218 1.45123 0.0953369 1.63514 0.288003C1.81905 0.48067 1.91036 0.718003 1.90909 1V10H9.54545V4C9.54545 3.45 9.73255 2.97934 10.1067 2.588C10.4809 2.19667 10.9302 2.00067 11.4545 2H17.1818C18.2318 2 19.1307 2.39167 19.8784 3.175C20.6261 3.95834 21 4.9 21 6V14C21 14.2833 20.9084 14.521 20.7251 14.713C20.5418 14.905 20.3153 15.0007 20.0455 15C19.7756 14.9993 19.5491 14.9033 19.3658 14.712C19.1825 14.5207 19.0909 14.2833 19.0909 14V12H1.90909V14C1.90909 14.2833 1.81745 14.521 1.63418 14.713C1.45091 14.905 1.22436 15.0007 0.954545 15ZM5.72727 9C4.93182 9 4.25568 8.70833 3.69886 8.125C3.14205 7.54167 2.86364 6.83333 2.86364 6C2.86364 5.16667 3.14205 4.45833 3.69886 3.875C4.25568 3.29167 4.93182 3 5.72727 3C6.52273 3 7.19886 3.29167 7.75568 3.875C8.3125 4.45833 8.59091 5.16667 8.59091 6C8.59091 6.83333 8.3125 7.54167 7.75568 8.125C7.19886 8.70833 6.52273 9 5.72727 9Z",
    fill: "#000636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.42a18cb34401e3bfde828936fc149824.svg";
export { ForwardRef as ReactComponent };